export default __webpack_public_path__ + "static/media/History.78c231dd.svg";